import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepMember extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Member: Resource Representations</h1>
				<h2>Rating</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> user_name </td>
							<td> String </td>
							<td>  </td>
							<td> </td>
						</tr>
						<tr>
							<td> rating </td>
							<td> List </td>
							<td>  </td>
							<td> </td>
						</tr>
						<tr>
							<td> rating[] </td>
							<td> List </td>
							<td>  </td>
							<td> </td>
						</tr>
						<tr>
							<td> </td>
							<td> PRAISE, NEUTRAL, COMPLAINT </td>
							<td>  </td>
							<td> </td>
						</tr>
					</tbody>
				</table>

				<h2>Note</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> note_id </td>
							<td> Integer </td>
							<td>  </td>
							<td> </td>
						</tr>
						<tr>
							<td> user_name </td>
							<td> String </td>
							<td>  </td>
							<td> </td>
						</tr>
						<tr>
							<td> note_text </td>
							<td> String </td>
							<td>  </td>
							<td> </td>
						</tr>
						<tr>
							<td> date_noted </td>
							<td> String </td>
							<td>  </td>
							<td> </td>
						</tr>
					</tbody>
				</table>
			</section>
		);
	}
}